export const MILLIS_OF_SECOND = 1000;
export const SECONDS_OF_MIN = 60;
export const MINS_OF_HOUR = 60;
export const HOURS_OF_DAY = 24;
